export const TRANSLATION_PATHS = {
  AUTH: "/i18n/auth/",
  CUSTOMER: {
    SHARED: "/i18n/customer/shared/",
    COMMON: "/i18n/customer/common/",
    LANGUAGE: "/i18n/customer/language/",
    SERVICE: "/i18n/customer/service/",
    INFO: "/i18n/customer/info/",
    TICKET: "/i18n/customer/ticket/",
    FEEDBACK: "/i18n/customer/feedback/",
  },
};
